const C = {
  name: "JapaneseYen",
  dimensions: { width: 40, height: 40 },
  content: `
    <g>
      <path fill="currentColor" stroke="none" d="M20 0C8.97 0 0 8.97 0 20C0 31.03 8.97 40 20 40C31.03 40 40 31.03 40 20C40 8.97 31.03 0 20 0ZM20 38C10.07 38 2 29.92 2 20C2 10.07 10.07 2 20 2C29.92 2 38 10.07 38 20C38 29.92 29.92 38 20 38Z"/>
      <path fill="currentColor" stroke="none" d="M24.4101 10.09C23.9101 9.86 23.3201 10.09 23.0901 10.6L20.0001 17.54L16.9101 10.6C16.6901 10.1 16.0901 9.87 15.5901 10.09C15.0901 10.31 14.8601 10.9 15.0801 11.41L18.4601 19H16.0001C15.4501 19 15.0001 19.45 15.0001 20C15.0001 20.55 15.4501 21 16.0001 21H19.0001V24.06H16.0001C15.4501 24.06 15.0001 24.51 15.0001 25.06C15.0001 25.61 15.4501 26.06 16.0001 26.06H19.0001V29C19.0001 29.55 19.4501 30 20.0001 30C20.5501 30 21.0001 29.55 21.0001 29V26.06H24.0001C24.5501 26.06 25.0001 25.61 25.0001 25.06C25.0001 24.51 24.5501 24.06 24.0001 24.06H21.0001V21H24.0001C24.5501 21 25.0001 20.55 25.0001 20C25.0001 19.45 24.5501 19 24.0001 19H21.5401L24.9201 11.41C25.1401 10.9 24.9101 10.31 24.4101 10.09Z"/>
    </g>
  `
};
export {
  C as JapaneseYen
};
